module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "report-overview"
  }, [_c('el-row', {
    staticClass: "ro-tool-bar"
  }, [_c('el-button', {
    staticClass: "ro-btn",
    attrs: {
      "loading": _vm.csvLoading
    },
    on: {
      "click": _vm.getCSVData
    }
  }, [_vm._v("\n\t\t\t\t下載報表\n\t\t\t")]), _vm._v(" "), _c('downloadCsv', {
    ref: "downloadCsv",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data": _vm.csvData,
      "name": "data.csv",
      "labels": _vm.labels
    }
  })], 1), _vm._v(" "), _vm._l((_vm.overview), function(dep, index) {
    return _c('el-row', {
      key: dep.depId,
      staticClass: "overview-table"
    }, [(index === 0) ? _c('el-row', {
      staticClass: "overview-title"
    }, [_c('el-col', {
      staticClass: "overview-col1",
      attrs: {
        "span": 8
      }
    }, [_vm._v(_vm._s(dep.title))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("部門人數")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("使用人數")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("使用率")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("活躍人數")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("活躍率")])], 1) : _c('el-row', {
      staticClass: "overview-title"
    }, [_c('el-col', {
      staticClass: "overview-col1",
      attrs: {
        "span": 8
      }
    }, [_vm._v(_vm._s(dep.title))])], 1), _vm._v(" "), _vm._l((dep.actual_dep), function(actual_dep) {
      return _c('el-row', {
        key: actual_dep.id,
        staticClass: "overview-data"
      }, [_c('el-col', {
        staticClass: "overview-col1",
        attrs: {
          "span": 8
        }
      }, [_vm._v(_vm._s(actual_dep.name))]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 4
        }
      }, [_vm._v(_vm._s(actual_dep.members))]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v(_vm._s(actual_dep.usage_members))]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v(_vm._s(actual_dep.usage_rate) + "%")]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v(_vm._s(actual_dep.active_members))]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_vm._v(_vm._s(actual_dep.active_rate) + "%")])], 1)
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593bcd6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/ReportOverview.vue
// module id = 927
// module chunks = 170